import { css } from 'styled-components';
import { fluid } from './fluid';
export const SitePaddingMin = 15;
export const SitePaddingMax = 50;
export const SiteWidth = 1756;
export const SiteWidthBreakpoint = SiteWidth + SitePaddingMax * 2;
export const siteWide = css `
  /* The minimum amount of space between the content and the edge of the viewport. */
  --sitePadding: ${fluid(SitePaddingMin, SitePaddingMax)};

  /* Max site container width */
  --siteWidth: calc(${SiteWidth}px + (var(--sitePadding) * 2));

  /* The amount of space between the edge of the site container and the viewport, will be 0px on smaller screens. */
  --siteMargin: calc((100vw - min(var(--siteWidth), 100vw)) / 2);

  margin: 0 auto;
  max-width: var(--siteWidth);
  padding: 0 var(--sitePadding);
  width: 100%;
`;
export const baseGrid = css `
  --gutterWidth: ${fluid(10, 32)};

  display: grid;
  column-gap: var(--gutterWidth);
  grid-template-columns: repeat(12, 1fr);
`;
